<template>
    <div v-if="itemIds.length > 0">
      <AtomsTextHeader :type="2" class="header--with-line">{{ $t('Poslední prohlížené') }}</AtomsTextHeader>
      <OrganismsListsWareList :items="recentItems" type="slider" :withSliderPagination="true" list-name="Poslední prohlížené produkty"></OrganismsListsWareList>
    </div>
</template>
<script setup>

const appConfig = useAppConfig();
const locale = useLocale();

const itemIds = useRecentlyViewedItems().getItemIds();
let recentItems;

if (itemIds.length > 0) {
  recentItems = (await useApiFetch(`/api/wareList?idWares=${itemIds.join(',')}&withoutParameters=true&sort=cheapest&take=12&currencyId=${locale.getLocale().currencyId}&languageId=${locale.getLocale().languageId}`)).data.value.wareList.wares.items;

  recentItems = itemIds.filter(item => recentItems.find(q => q.id === item)).map(item => recentItems.find(q => q.id === item));
}

</script>